/**
 * Reduced-motion awareness for gesture-driven animations.
 *
 * Gestures themselves stay responsive under `prefers-reduced-motion` (the finger
 * still drags the surface), but the post-release *commit* slide should collapse
 * to an instant state change so we honour the user's accessibility preference.
 * SSR-safe: returns `false` when `matchMedia` is unavailable.
 */

// oxlint-disable-next-line lingui/no-unlocalized-strings -- media query CSS, no UI
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion(): boolean {
  return globalThis.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;
}
